import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
@Injectable()
export class LoaderService {
    isLoading = new BehaviorSubject<boolean>(false);
    private pendingRequests = 0;
    private showTimer: any = null;
    private readonly showDelayMs = 150;
    private safetyResetTimer: any = null;
    private readonly maxPendingMs = 20000;

    constructor(private router: Router) {}

    private isDashboardRoute(): boolean {
        return this.router?.url?.includes('/dashboard') || false;
    }

    show() {
        // Dashboard widgets still contain legacy manual show/hide calls; ignore
        // manual toggles there and rely on interceptor request lifecycle only.
        if (this.isDashboardRoute()) {
            return;
        }
        this.pendingRequests++;
        this.clearShowTimer();
        this.isLoading.next(true);
        this.scheduleSafetyReset();
    }

    hide() {
        if (this.isDashboardRoute()) {
            return;
        }
        if (this.pendingRequests > 0) {
            this.pendingRequests--;
        }

        if (this.pendingRequests === 0) {
            this.clearShowTimer();
            this.clearSafetyResetTimer();
            this.isLoading.next(false);
        }
    }

    requestStarted() {
        this.pendingRequests++;
        this.scheduleSafetyReset();

        if (this.pendingRequests === 1) {
            this.clearShowTimer();
            this.showTimer = setTimeout(() => {
                if (this.pendingRequests > 0) {
                    this.isLoading.next(true);
                }
            }, this.showDelayMs);
        }
    }

    requestEnded() {
        if (this.pendingRequests > 0) {
            this.pendingRequests--;
        }

        if (this.pendingRequests === 0) {
            this.clearShowTimer();
            this.clearSafetyResetTimer();
            this.isLoading.next(false);
        }
    }

    private clearShowTimer() {
        if (this.showTimer) {
            clearTimeout(this.showTimer);
            this.showTimer = null;
        }
    }

    private scheduleSafetyReset() {
        this.clearSafetyResetTimer();
        this.safetyResetTimer = setTimeout(() => {
            if (this.pendingRequests > 0) {
                this.pendingRequests = 0;
                this.isLoading.next(false);
            }
            this.clearShowTimer();
            this.clearSafetyResetTimer();
        }, this.maxPendingMs);
    }

    private clearSafetyResetTimer() {
        if (this.safetyResetTimer) {
            clearTimeout(this.safetyResetTimer);
            this.safetyResetTimer = null;
        }
    }
}
